import { ErrorHandler } from './errorHandler';
import axios, { AxiosInstance } from 'axios';
import { Service } from 'vue-di-container';
// import store from '../Store/Store';
// import UserStore from '../Store/module/UserStore';

@Service()
export default class AxiosService {
  public axiosInstance: AxiosInstance;

  constructor() {
    const config = {
      baseURL: process.env.BASE_URL,
      // timeout: 60 * 1000, // Timeout
      // withCredentials: true, // Check cross-site Access-Control
    };

    this.axiosInstance = axios.create(config);

    this.axiosInstance.interceptors.request.use(
      (axiosRequestConfig) => {
        // var token = UserStore.state['_mofatoken'];
        // UserStore //store.getters['mofatoken']// UserStore.getters[types.MOFA_TOKEN]; //store.getters[types.MOFA_TOKEN];
        // axiosRequestConfig.headers["mofaxxx"] = `${token}`;
        return axiosRequestConfig;
      },
      (error) => ErrorHandler.errorResponseHandler(error)
    );

    // Add a response interceptor
    this.axiosInstance.interceptors.response.use(
      function(axiosResponse) {
        // var mofax = axiosResponse.headers['mofaxxx'];
        // if(mofax){
        // store.dispatch('updateMofaToken',mofax);
        // }
        return axiosResponse;
      },
      (error) => {
        ErrorHandler.errorResponseHandler(error);

        return Promise.reject(error.response);
      }
    );
  }
}
